import React, {useContext} from "react";
import {useRenderableData} from "../common/hooks/useRenderableData";
import {ExpandingPillButtonSection} from "../common/ExpandingPillButtonSection";
import {PrepareInvoiceForBillingForm} from "./PrepareInvoiceForBillingForm";
import {LeaveWithoutSavingWarningUtility} from "../common/LeaveWithoutSavingWarningUtility";
import {MessageDisplayerUtility} from "../common/MessageDisplayerUtility";
import {OverlayLoadingIndicator} from "../common/OverlayLoadingIndicator";
import {ConditionalRenderer} from "../common/ConditionalRenderer";
import {ApiUtility} from "../common/ApiUtility";
import {GlobalContext} from "../admin-frame/AdminFrame";
import {PillButton} from "../common/PillButton";
import {CollapsibleInvoiceFpDataDisplay} from "./CollapsibleInvoiceFpDataDisplay";

export let UpdateNotTrackedInvoice = function (props) {
    const fpInvoiceDataAnchor = `invoice-fp-data-${props.fpInvoice.invoicenumber}`;
    const context = useContext(GlobalContext);
    let renderableData = useRenderableData({
        showPrepareForm: false,
        loading: false
    })

    function save(formModelData) {
        renderableData.updateAndRender({loading: true})
        ApiUtility.billInvoice(formModelData)
            .then((billedInvoice) => {
                LeaveWithoutSavingWarningUtility.disableLeaveWithoutSavingWarnings(context);
                MessageDisplayerUtility.success(`Successfully billed invoice.`);
                props.afterSuccessfulSave(billedInvoice.id)
            })
            .catch((err) => {
                renderableData.updateAndRender({loading: false});
                console && console.error(err);
                MessageDisplayerUtility.error(`An error occurred while updating the invoice.`);
            });
    }

    function onClickMakeSubscription() {
        props.onClickMakeSubscription(props.fpInvoice.id)
    }

    return (
        <div className="update-not-tracked-invoice-container">
            <ConditionalRenderer if={renderableData.loading} renderer={() => (
                <OverlayLoadingIndicator/>
            )}/>
            <div className="invoice-summary">
                <div className="invoice-summary-content">
                    <div className="invoice-summary-left">
                        <div>
                            This invoice is not currently tracked by the billing system. The data displayed here is from
                            the <a className="text-link" href={`#${fpInvoiceDataAnchor}`}>FP invoice</a>.
                        </div>
                    </div>
                    <div className="invoice-summary-right">
                        <PillButton
                            onClick={onClickMakeSubscription}
                            containerClasses="make-subscription-button-container"
                            buttonClasses="make-subscription-button"
                            rightIconSrc={"/static/images/arrow-out-white.svg"}
                            buttonText="MAKE SUBSCRIPTION"
                            title="Create a subscription using this invoice data"
                        />
                    </div>
                </div>
            </div>
            <div className="invoice-prep-section">
                <ExpandingPillButtonSection
                    buttonText="Prepare invoice for billing (as one-off invoice)"
                    expandingContentRenderer={() => (
                        <PrepareInvoiceForBillingForm
                            invoice={props.invoice}
                            fpInvoice={props.fpInvoice}
                            fpInvoiceItems={props.fpInvoiceItems}
                            save={save}
                        />
                    )}
                />
            </div>
            <CollapsibleInvoiceFpDataDisplay
                fpInvoiceDataAnchor={fpInvoiceDataAnchor}
                fpInvoice={props.fpInvoice}
            />
        </div>
    );
};
